<script lang="ts">
    import { onMount } from "svelte";
    import type { Concert } from "../../../static";
    import { audioMotion, type Audio } from "../audio";
    import Button from "../components/Button.svelte";
    import { fade } from "svelte/transition";

    interface Props {
        concert: Concert;
        audio: Audio;
    }

    const { concert, audio }: Props = $props();

    let isReady = $state(audio.isReady);
    let showSetupComplete = $state(true);

    onMount(() => {
        gtag("event", "page_view", { page_title: "PlayerScreen" });

        setTimeout(() => {
            showSetupComplete = false;
        }, 3000);
    });
</script>

<div
    class="fixed inset-0 scale-[200%]"
    use:audioMotion={{
        audio,
        color: concert.visualizer.color,
        radius: concert.visualizer.radius,
    }}
></div>

{#if !isReady}
    <div class="fixed inset-0 flex items-center justify-center bg-black/10 p-[20px]">
        <Button onclick={() => (isReady = true)} color="var(--color-green-500)">
            Resume Audio
        </Button>
    </div>
{:else if showSetupComplete}
    <div
        class="fixed inset-0 flex items-center justify-center bg-black/10 p-[20px]"
        transition:fade
    >
        <h1 class="text-center text-2xl font-semibold drop-shadow-md drop-shadow-black">
            Setup complete
        </h1>
    </div>
{/if}
